<template>
  <svg :width="width" :height="height" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19 16C19 14.3431 17.6569 13 16 13C14.3431 13 13 14.3431 13 16C13 17.6569 14.3431 19 16 19C17.6569 19 19 17.6569 19 16ZM14.5 16C14.5 15.1716 15.1716 14.5 16 14.5C16.8284 14.5 17.5 15.1716 17.5 16C17.5 16.8284 16.8284 17.5 16 17.5C15.1716 17.5 14.5 16.8284 14.5 16Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16 4.8897C10.3287 4.8897 6.42996 8.11623 4.41084 14.4106C4.21789 15.0121 4.80951 15.5682 5.39792 15.3383C10.1217 13.4928 13.6686 12.5747 16 12.5747C18.3314 12.5747 21.8783 13.4928 26.6021 15.3383C27.1905 15.5682 27.7821 15.0121 27.5892 14.4106C25.57 8.11623 21.6713 4.8897 16 4.8897ZM16.2606 6.39226C20.5783 6.47767 23.6448 8.69932 25.5322 13.1643L25.612 13.3577L25.4733 13.3072C21.4089 11.821 18.26 11.0747 16 11.0747L15.771 11.0772C13.6064 11.1236 10.6666 11.8199 6.93012 13.161L6.38725 13.3577L6.46781 13.1643C8.39298 8.61002 11.5448 6.3897 16 6.3897L16.2606 6.39226Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.62882 18.2433C8.07324 17.1209 9.58485 16.5713 10.3525 16.5713C11.9161 16.5713 13.981 18.448 15.0394 20.9005C15.4919 21.9491 15.6781 23.7975 15.6346 26.512C15.6267 27.0033 15.1565 27.3545 14.6832 27.2224C11.89 26.4431 9.87791 25.421 8.64806 24.1243C7.47766 22.8903 6.35712 21.2758 5.28161 19.2808C5.0761 18.8996 5.23525 18.424 5.62882 18.2433ZM13.6622 21.4948C12.816 19.5341 11.2065 18.0713 10.3525 18.0713C9.96082 18.0713 8.8551 18.453 7.15423 19.2016L6.9925 19.273L7.23416 19.6866C7.9823 20.9447 8.74568 22.0029 9.52245 22.8611L9.7364 23.0921C10.5797 23.9812 11.9584 24.7584 13.8731 25.4053L14.1393 25.4927L14.1334 25.0514C14.1001 23.4107 13.9512 22.2488 13.7025 21.5945L13.6622 21.4948Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.0381 16.5713C22.8057 16.5713 24.3173 17.1209 26.7617 18.2433C27.1553 18.424 27.3144 18.8996 27.1089 19.2808C26.0334 21.2758 24.9129 22.8903 23.7425 24.1243C22.5126 25.421 20.5006 26.4431 17.7074 27.2224C17.2341 27.3545 16.7638 27.0033 16.7559 26.512C16.7125 23.7975 16.8986 21.9491 17.3512 20.9005C18.4096 18.448 20.4745 16.5713 22.0381 16.5713ZM22.0381 18.0713C21.1841 18.0713 19.5746 19.5341 18.7284 21.4948L18.6881 21.5945C18.4394 22.2488 18.2904 23.4107 18.2571 25.0514L18.2513 25.4927L18.5174 25.4053C20.4321 24.7584 21.8108 23.9812 22.6541 23.0921L22.8681 22.8611C23.6449 22.0029 24.4083 20.9447 25.1564 19.6866L25.398 19.273L25.2363 19.2016C23.5354 18.453 22.4297 18.0713 22.0381 18.0713Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31C24.2843 31 31 24.2843 31 16ZM2.5 16C2.5 8.54416 8.54416 2.5 16 2.5C23.4558 2.5 29.5 8.54416 29.5 16C29.5 23.4558 23.4558 29.5 16 29.5C8.54416 29.5 2.5 23.4558 2.5 16Z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'DriveIcon',
  props: {
    width: {
      type: Number,
      default: 32,
    },
    height: {
      type: Number,
      default: 32,
    },
    color: {
      type: String,
      default: '#4B4C52',
    },
  },
};
</script>
